/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DivisionDto as DigiworkMaitreDPosDtoDivisionDto } from '../../models/Digiwork/MaitreD/Pos/DTO/division-dto';

export interface GetDivision$Params {
  divisionId: string;
}

export function getDivision(http: HttpClient, rootUrl: string, params: GetDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
  const rb = new RequestBuilder(rootUrl, getDivision.PATH, 'get');
  if (params) {
    rb.path('divisionId', params.divisionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>;
    })
  );
}

getDivision.PATH = '/api/divisions/{divisionId}';
